export default {
  namespaced: true,
  state: {
    settingCategorys: [],
    halfPayoutCategorys: []
  }
};
